/* sb-dc-keys.js — make "send forward / backward" reachable on every machine,
   and make the Shortcuts panel readable without scrolling sideways.

   The reorder handler itself was fine: driving it directly reorders layers
   correctly in both directions. What was not fine is getting the keypress to
   it.

     · On macOS, Cmd+[ and Cmd+] are the browser's Back and Forward.
       Depending on focus the page may never see them.
     · e.key for a bracket depends on the keyboard layout. On layouts where
       the bracket needs AltGr, or under a Korean IME, e.key is not "[" and
       the existing check misses.

   So: keep the brackets, match them by physical key as well as by character,
   and add Ctrl/Cmd + Shift + Arrow Up/Down, which no browser claims and which
   is the same physical key on every layout.

   The panel: its grid asks for two ~350px columns inside a 680px dialog, so
   the content was 81px wider than the box and the last column sat behind a
   horizontal scrollbar. Widened, and the columns are told they may shrink.

   Loads after the augment bundle, so this wrapper sits outside the one the
   multi-select module already installed and delegates everything else to it. */
(function () {
  'use strict';

  function typing(t) {
    return !!(t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' ||
                    t.tagName === 'SELECT' || t.isContentEditable));
  }

  /* +1 = forward (towards the viewer), -1 = backward */
  function reorder(dir) {
    var a = window.__dcApi;
    var sel = a && a.selected;
    if (!a || !sel || sel.locked) return false;
    try { a.reorderLayer(sel.id, dir); } catch (e) { return false; }
    try {
      if (window.__dcToast) window.__dcToast(dir > 0 ? 'Brought forward' : 'Sent backward');
    } catch (e) {}
    return true;
  }

  var prev = window.__dcShortcut;
  window.__dcShortcut = function (e) {
    try {
      if (!typing(e.target)) {
        var mod = e.metaKey || e.ctrlKey;
        if (mod) {
          // physical key first — survives layouts where e.key is not a bracket
          var code = e.code;
          var isRight = code === 'BracketRight' || e.key === ']';
          var isLeft  = code === 'BracketLeft'  || e.key === '[';
          if (isRight || isLeft) {
            if (reorder(isRight ? 1 : -1)) { e.preventDefault(); return true; }
          }
          if (e.shiftKey && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
            if (reorder(e.key === 'ArrowUp' ? 1 : -1)) { e.preventDefault(); return true; }
          }
        }
      }
    } catch (err) {}
    return prev ? prev.apply(this, arguments) : false;
  };

  /* ---------------------------------------------------------------- panel */
  /* The panel is built inside the augment bundle, so its layout is corrected
     from here rather than by rebuilding that 322KB file. */
  var CSS_ID = 'sbdc-keys-css';
  function injectCss() {
    if (document.getElementById(CSS_ID)) return;
    var st = document.createElement('style');
    st.id = CSS_ID;
    st.textContent = [
      /* room for two columns instead of 81px too little */
      '.sbdc-modal.sbdc-keys{width:min(1000px,94vw) !important;max-width:94vw !important}',
      /* minmax(0,...) is what actually lets a grid column shrink below its
         content; without it the track keeps the widest row is width */
      '.sbdc-keygrid{grid-template-columns:repeat(2,minmax(0,1fr)) !important;',
      '  width:auto !important;overflow-x:visible !important;padding:18px 22px 22px !important;',
      '  column-gap:34px !important;row-gap:2px !important}',
      '.sbdc-keyrow{align-items:flex-start !important;gap:14px !important;padding:7px 0 !important}',
      /* the key cap keeps its own width, the description takes the rest */
      '.sbdc-keyrow > .sbdc-kbd{flex:0 0 auto !important}',
      '.sbdc-keyrow > :not(.sbdc-kbd){flex:1 1 auto !important;min-width:0 !important;',
      '  text-align:left !important;line-height:1.35 !important}',
      '.sbdc-kbd{line-height:1.5 !important}',
      /* one column when there is not room for two */
      '@media (max-width:900px){.sbdc-keygrid{grid-template-columns:1fr !important}}'
    ].join('\n');
    document.head.appendChild(st);
  }

  /* Rows whose key list grew a second combo. A <br> still breaks inside
     white-space:nowrap, so the cap stays on two tidy lines instead of
     stretching the column. */
  function fixHelp() {
    var rows = document.querySelectorAll('.sbdc-keyrow');
    if (!rows.length) return;
    injectCss();
    rows.forEach(function (r) {
      if (r.dataset.sbKeysFixed) return;
      var kbd = r.querySelector('.sbdc-kbd');
      if (!kbd) return;
      var t = kbd.textContent.replace(/\s+/g, ' ').trim();
      if (t === 'Ctrl / Cmd + ]') {
        kbd.innerHTML = 'Ctrl / Cmd + ]<br>Ctrl / Cmd + Shift + \u2191';
        r.dataset.sbKeysFixed = '1';
      } else if (t === 'Ctrl / Cmd + [') {
        kbd.innerHTML = 'Ctrl / Cmd + [<br>Ctrl / Cmd + Shift + \u2193';
        r.dataset.sbKeysFixed = '1';
      }
    });
  }

  if (typeof MutationObserver === 'function') {
    var pend = 0;
    var mo = new MutationObserver(function () {
      if (pend) return;
      pend = setTimeout(function () { pend = 0; try { fixHelp(); } catch (e) {} }, 120);
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pagehide', function () {
      try { mo.disconnect(); } catch (e) {}
      if (pend) { clearTimeout(pend); pend = 0; }
    });
  }
  fixHelp();

  window.__dcReorderSel = reorder;                 // test hook
})();
